const ISO_DATE = /^\d{4}-\d{2}-\d{2}(T[\d:.]+Z?)?$/;

function parseIsoDate(value: string): Date | null {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
  if (!m) return null;
  const date = new Date(Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3])));
  return Number.isNaN(date.getTime()) ? null : date;
}

function collectDates(node: any, acc: Date[]): void {
  if (node == null) return;
  if (typeof node === "string") {
    if (ISO_DATE.test(node)) {
      const parsed = parseIsoDate(node);
      if (parsed) acc.push(parsed);
    }
    return;
  }
  if (Array.isArray(node)) {
    node.forEach((child) => collectDates(child, acc));
    return;
  }
  if (typeof node === "object") {
    Object.values(node).forEach((child) => collectDates(child, acc));
  }
}

function shiftIsoYears(value: string, years: number): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})(.*)$/.exec(value);
  if (!m) return value;
  const year = Number(m[1]) + years;
  const month = Number(m[2]);
  let day = Number(m[3]);
  if (month === 2 && day === 29) {
    const isLeap = (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    if (!isLeap) day = 28;
  }
  return `${String(year).padStart(4, "0")}-${m[2]}-${String(day).padStart(2, "0")}${m[4] ?? ""}`;
}

function applyShift(node: any, years: number): any {
  if (node == null) return node;
  if (typeof node === "string") return ISO_DATE.test(node) ? shiftIsoYears(node, years) : node;
  if (Array.isArray(node)) return node.map((child) => applyShift(child, years));
  if (typeof node === "object") {
    const out: Record<string, any> = {};
    for (const key of Object.keys(node)) out[key] = applyShift(node[key], years);
    return out;
  }
  return node;
}

export function rollItineraryDatesToFuture(itinerary: any, now: Date = new Date()): any {
  if (itinerary == null || typeof itinerary !== "object") return itinerary;
  const dates: Date[] = [];
  collectDates(itinerary, dates);
  if (dates.length === 0) return itinerary;
  const earliest = new Date(Math.min(...dates.map((d) => d.getTime())));
  const todayUtc = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
  if (earliest.getTime() >= todayUtc) return itinerary;
  let years = 1;
  while (
    Date.UTC(earliest.getUTCFullYear() + years, earliest.getUTCMonth(), earliest.getUTCDate()) <
    todayUtc
  ) {
    years += 1;
  }
  return applyShift(itinerary, years);
}
